import { createClient } from '@/shared/api';
import type {
  ResolveFlaggedStudyMutation,
  ResolveFlaggedStudyMutationVariables,
} from '@/shared/api';
import RESOLVE_FLAGGED_STUDY_MUTATION from '../mutations/resolveFlaggedStudy';

/**
 * Resolves or skips a flagged study during flagged-study review. Runs RESOLVE_FLAGGED_STUDY_MUTATION with the resolve and skip flags and throws resolveFlaggedStudy.message when isSuccess is false.
 *
 * @param studyId - Identifier of the flagged study.
 * @param isResolved - Whether the flag is being marked resolved.
 * @param isSkip - Whether the flag is being skipped instead of resolved.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleResolveFlaggedStudy = async (studyId: any, isResolved: any, isSkip: any) => {
  const client = createClient();
  const resolveFlaggedStudyResult = await client.mutate<
    ResolveFlaggedStudyMutation,
    ResolveFlaggedStudyMutationVariables
  >({
    mutation: RESOLVE_FLAGGED_STUDY_MUTATION,
    variables: {
      studyId,
      isResolved,
      isSkip,
    },
  });
  const { data } = resolveFlaggedStudyResult;
  const { resolveFlaggedStudy } = data ?? {};
  if (!resolveFlaggedStudy?.isSuccess) {
    throw new Error(resolveFlaggedStudy?.message ?? undefined);
  }
};

export default handleResolveFlaggedStudy;
